export enum AppointmentState {
  CANCELLED = 'Cancelled',
  NO_SHOW = 'No show',
  CONFIRMED = 'Confirmed',
  SCHEDULED = 'Scheduled',
}
